<style>
    .chatbot-container {
        position: relative;
        bottom: 0;
        right: 7%;
        z-index: 1000;
        transition: all 0.3s ease;
        border-radius: 10px;
        transition: all 0.3s ease;
        border-radius: 10px;
        z-index: 999;
    }
    .toggle-button-container {
        position: absolute;
        right: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 320px;
        margin-left: auto;
        margin-right: inherit;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border: 1px solid rgb(202, 202, 202);
        background: #fff;
    }
    .toggle-button {
        cursor: pointer;
        width: auto;
        color: rgb(202, 202, 202);
        background: inherit;
        z-index: 3;
        margin-left: auto;
        margin-right: inherit;
    }
    .toggle-button span {
        position: absolute;
        top: 4px;
        right: 10px;
        z-index: 2;
    }

    .label-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: auto;
    }

    .toggle-label {
        margin-left: 20px;
    }
</style>
<script lang="ts">
  	import { DeepChat } from "deep-chat";
  	import { afterUpdate, onMount } from 'svelte';
  	import { writable } from 'svelte/store';

    let deepChat: DeepChat;

    let isMinimized = writable(true);

  	onMount(async () => {
        await import("deep-chat-dev");
        isLoaded = true;
    });

    afterUpdate(() => {
	    const chatElementRef = document.getElementById('chat-element');
        if (!chatElementRef) return;
        chatElementRef.htmlClassUtilities = {
            ['custom-button']: {
                events: {
                click: (event) => {
                    const text = event.target.children[0].innerText;
                    chatElementRef.submitUserMessage( { text: text.substring(1, text.length - 1) } );
                },
                },
                styles: {
                default: {backgroundColor: '#f2f2f2', borderRadius: '10px', padding: '10px', cursor: 'pointer', textAlign: 'center'},
                hover: {backgroundColor: '#ebebeb'},
                click: {backgroundColor: '#e4e4e4'},
                },
            },
            ['custom-button-text']: {styles: {default: {pointerEvents: 'none'}}},
        };
	});

    let isLoaded = false;

    const directConnection = {
      openAI: {
          key: process.env.OPENAI_KEY,
          assistant: {
            assistant_id: process.env.OPENAI_ASSISTANT_ID,
            load_thread_history: false
          }
      }
    };

    const messageStyles = {
      default: {
          shared: {
            bubble: {
              maxWidth: "100%", backgroundColor: "unset", marginTop: "10px", marginBottom: "10px"}},
          user: {
            bubble: {
              marginLeft: "0px", color: "black"}},
          ai: {
            outerContainer: {
              backgroundColor: "rgba(247,247,248)", borderTop: "1px solid rgba(0,0,0,.1)", borderBottom: "1px solid rgba(0,0,0,.1)"
            }
          }
        }
      };
    
    const avatars = {
	  default: { styles: { position: "left" } },
	  ai: { src: "./assets/images/chatgpt-icon.png" }
	};
    
	const submitButtonStyles = {
        submit: {
          container: {
            default: { backgroundColor: "#19c37d" },
            hover: { backgroundColor: "#0bab69" },
            click: { backgroundColor: "#068e56" }
          },
          svg: {
            content: "<?xml version=\"1.0\" ?> <svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"> <g> <path d=\"M21.66,12a2,2,0,0,1-1.14,1.81L5.87,20.75A2.08,2.08,0,0,1,5,21a2,2,0,0,1-1.82-2.82L5.46,13H11a1,1,0,0,0,0-2H5.46L3.18,5.87A2,2,0,0,1,5.86,3.25h0l14.65,6.94A2,2,0,0,1,21.66,12Z\"> </path> </g> </svg>",
            styles: {
              default: {
                width: "1.3em",
                marginTop: "0.15em",
                filter: "brightness(0) saturate(100%) invert(100%) sepia(28%) saturate(2%) hue-rotate(69deg) brightness(107%) contrast(100%)"
              }
            }
          }
        },
        loading: {
          container: { default: { backgroundColor: "white" } },
          svg: {
            styles: {
              default: { filter: "brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)" }
            }
          }
        },
        stop: {
          container: {
            default: { backgroundColor: "white" },
            hover: { backgroundColor: "#dadada52" }
          },
          svg: {
            content: "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"> <rect width=\"24\" height=\"24\" rx=\"4\" ry=\"4\" /> </svg>",
            styles: {
              default: {
                width: "0.95em",
                marginTop: "0.32em",
                filter: "brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)"}
            }
          }
        }
      };
	
	const textInput = {placeholder: { text: "Benvenuto su MobilityPlatform!" } };
</script>

  {#if isLoaded}
    <div class="chatbot-container">
        <div class="toggle-button-container" style:top={$isMinimized ? '-35px' : '-380px'}>
            <div class="label-container">
                <span class="toggle-label">ChatGPT Assistant</span>
            </div>
            <button class="toggle-button" on:click={() => isMinimized.update(n => !n)}>
                {#if $isMinimized}
                    <span class="material-icons-outlined">maximize</span>
                {:else}
                    <span class="material-icons-outlined">minimize</span>
                {/if}
            </button>
        </div>
        <deep-chat
            style:display={$isMinimized ? 'none' : 'block'}
            style="position: fixed; bottom: 0px; right: 7%; z-index: 1"
            messageStyles={messageStyles}
            avatars={avatars}
            submitButtonStyles={submitButtonStyles}
            directConnection={directConnection}
            textInput={textInput}
            id="chat-element"
        >
            <div style="display: none">
                <div class="custom-button">
                    <div class="custom-button-text">"Cosa è MobilityPlatform"</div>
                </div>
                <div class="custom-button" style="margin-top: 15px">
                    <div class="custom-button-text">"Come mi puoi aiutare"</div>
                </div>
            </div>
        </deep-chat>
    </div>
  {/if}